import axios, { AxiosError } from "axios";
import { store } from "lib/redux/store";
import { setAccessToken } from "lib/redux/uiSlice";
import { isTokenExpired } from "lib/utils/verifyJwt";

// Create an Axios instance for handling multipart/form-data
const axiosMultipartClient = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_BASE_URL,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "*/*",
  },
});

// Request interceptor to add Authorization token and handle token expiration
axiosMultipartClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access-token");
    if (!token || isTokenExpired(token)) {
      localStorage.removeItem("access-token");
      localStorage.setItem("auth-overlay", "true");
      store.dispatch(setAccessToken(null));
      return Promise.reject(
        new AxiosError("Token expired. Please log in again.", "TOKEN_EXPIRED")
      );
    } else {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
axiosMultipartClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      const { status, data } = error.response;

      // Customize based on error status codes
      switch (status) {
        case 400:
          console.error("Bad request:", data);
          break;
        case 401:
          console.error("Unauthorized, please log in.");
          localStorage.removeItem("access-token");
          break;
        case 404:
          console.error("Resource not found:", data);
          break;
        case 500:
          console.error("Server error:", data);
          break;
        default:
          console.error("Unhandled error:", data);
      }
    } else if (error.request) {
      console.error("No response received:", error.request);
    } else {
      console.error("Request setup error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosMultipartClient;
